module.exports = __webpack_public_path__ + "static/hatching-twitter-c27ae97ceadbdd7cf0989e32ec1f2dfc.jpg";